import './App.css';
import Navbar from './Component/Navbar';
import Hero from './Component/Hero';
 import Ticker from './Component/Ticker';
 import WhyChooseUs from './Component/WhyChooseUs';
 import HowItWorks from './Component/HowItWorks';
 import Testimonials from './Component/Testimonials';
import ContactForm from './Component/ContactForm';
 import Footer from './Component/Footer';
// import RatesSection from './Component/RatesSection';
// import WhyTrustUsSection from './Component/WhyTrustUsSection';//TestimonialsSection
// import TestimonialsSection from './Component/TestimonialsSection';//LocationsSection
// import LocationsSection from './Component/LocationsSection';//FAQSection
// import FAQSection from './Component/FAQSection';//c
// import ContactSection from './Component/ContactSection';//Footer
// import Footer from './Component/Footer';//Footer
// import AdCard from './Component/AdCard';//Footer








function App() {
  return (
    <div className="App">
      <Navbar/>
      <Hero/>
      <Ticker/>
      <WhyChooseUs/>
      <HowItWorks/>
      <Testimonials/>
      <ContactForm/>
      <Footer/>
     

    </div>
  )
}

export default App;
